import React from "react"
import { useTranslation } from "react-i18next"

import type {
  DashboardInfoTypeEnum,
  DashboardPaymentTypeEnum,
} from "@/enums"
import { useDashboard } from "@/hooks"

type DashboardRecurrenceStatusChartProps = {
  dashboardType:
    | DashboardInfoTypeEnum
    | DashboardPaymentTypeEnum
  searchParams?: SearchParamsType
}

export const DashboardRecurrenceStatusChart: React.FC<
  DashboardRecurrenceStatusChartProps
> = ({ dashboardType, searchParams }) => {
  const { t } = useTranslation()
  const { data: recurrenceStatus } = useDashboard({
    dashboardType: dashboardType as DashboardInfoTypeEnum,
    ...searchParams,
  })

  if (
    !recurrenceStatus?.indicator ||
    recurrenceStatus.indicator.length === 0
  ) {
    return (
      <div className="flex min-h-[100px] items-center justify-center text-sm text-muted-foreground">
        {t("pages.dashboard.noDataAvailable")}
      </div>
    )
  }

  return (
    <div className="space-y-2">
      {recurrenceStatus?.indicator?.map((status) => (
        <div
          key={status.key}
          className="flex items-center justify-between rounded-md bg-indigo-50/50 px-3 py-2 text-sm"
        >
          <span
            title={status.key}
            className="font-medium text-indigo-900"
          >
            {status.key}
          </span>
          <span className="rounded-full bg-indigo-100 px-3 py-1 text-sm font-semibold text-indigo-700">
            {status.value}
          </span>
        </div>
      ))}
    </div>
  )
}
